








import Vue from 'vue'
import SmallRowOfferEl from '@/components/elements/SmallRowOfferEl.vue'
import { SmallRowOfferElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SmallMultiRowOfferEl',

  components: { SmallRowOfferEl },

  props: {
    templateItemData: {
      type: Object as () => SmallRowOfferElInterface,
      required: true
    }
  }
})
